import { createAction } from '@reduxjs/toolkit'

export const fetchLatestRetrainerDagRun = createAction('CME_RETRAINER_FETCH_LATEST_RETRAINER_DAG_RUN')
export const triggerRetrainerDAG = createAction('CME_RETRAINER_TRIGGER_RETRAINER_DAG')
export const fetchLastSuccessfulRetrainedModel = createAction('CME_RETRAINER_FETCH_LAST_SUCCESSFUL_RETRAINED_MODEL')
export const fetchLatestDeploymentDagRun = createAction('CME_RETRAINER_FETCH_LATEST_DEPLOYMENT_DAG_RUN')
export const fetchCurrentProductionModel = createAction('CME_RETRAINER_FETCH_CURRENT_PRODUCTION_MODEL')
export const fetchRecentModels = createAction('CME_RETRAINER_FETCH_RECENT_MODELS')
export const triggerDeploymentDAG = createAction('CME_RETRAINER_TRIGGER_DEPLOYMENT_DAG')
